import React, { useEffect, useState } from "react";
import { ConfirmButton } from "../../components/ConfirmButton";
import { notification } from "../../helpers/notification";
import {
    addEvent,
    deleteEvent,
    getEvent,
    getEvents,
    updateEvent,
} from "../../services/eventServices";
import moment from "moment/moment";
import { getEventPlaces } from "../../services/eventPlaceServices";
import { useParams } from "react-router-dom";
import { EventSupplier } from "./EventSupplier";
import { AccreditedList } from "./AccreditedList";
import { EventPersonnelRegisteredList } from "./EventPersonnelRegisteredList";
import { AccreditedChefList } from "./AccreditedChefList";
import { onlyOfficeUser } from '../../helpers/utils';

export const EventDetail = () => {
    const [event, setEvent] = useState({});
    const [eventPlaceList, setEventPlaceList] = useState([]);
    const { uniqueKey } = useParams();
    const [activeTab, setActiveTab] = useState('1');

    const [formFields, setFormFields] = useState({
        name: "",
        totalPersonnelCount: 1,
        chiefSalary: 0,
        oggSalary: 0,
        placeUniqueKey: "",
        startDate: "",
        notes: "",
    });

    const [formErrors, setFormErrors] = useState({});

    const getData = () => {
        setEvent({});
        getEvent(uniqueKey).then((event) => {
            getEventPlaces().then((placeResult) => {
                setEventPlaceList(placeResult.items);
                setEvent(event);
                setFormFields({
                    name: event.name || "",
                    totalPersonnelCount: event.totalPersonnelCount || 1,
                    chiefSalary: event.chiefSalary || 0,
                    oggSalary: event.oggSalary || 0,
                    placeUniqueKey: event.placeUniqueKey || "",
                    startDate: event.startDate ? moment(event.startDate).format("YYYY-MM-DD") : "",
                    notes: event.notes || "",
                });
            });
        });
    };

    useEffect(() => {
        onlyOfficeUser();
        getData();
    }, []);

    const onCloseConfirm = (u, isClosed) => {
        updateEvent({
            uniqueKey: uniqueKey,
            isClosed: isClosed,
        }).then(() => {
            notification.success({
                message: "Kayıt başarıyla güncellendi.",
            });
            getData();
        }).catch(() => {
            notification.error({
                message: "Bir hata oluştu tekrar deneyiniz",
            });
        });
    };

    const onArchiveConfirm = () => {
        updateEvent({
            uniqueKey: uniqueKey,
            statusId: 2,
        }).then(() => {
            notification.success({
                message: "Kayıt başarıyla güncellendi.",
            });
            getData();
        }).catch(() => {
            notification.error({
                message: "Bir hata oluştu tekrar deneyiniz",
            });
        });
    };

    const validateForm = () => {
        const errors = {};
        if (!formFields.name) errors.name = "Etkinlik Adı zorunludur";
        if (!formFields.totalPersonnelCount) errors.totalPersonnelCount = "Personel sayısı zorunludur";
        if (!formFields.placeUniqueKey) errors.placeUniqueKey = "Mekan seçiniz";
        if (!formFields.startDate) errors.startDate = "Etkinlik Tarihi zorunludur";
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const saveForm = () => {
        if (!validateForm()) return;
        const payload = {
            uniqueKey: uniqueKey,
            name: formFields.name,
            totalPersonnelCount: Number(formFields.totalPersonnelCount),
            chiefSalary: Number(formFields.chiefSalary),
            oggSalary: Number(formFields.oggSalary),
            placeUniqueKey: formFields.placeUniqueKey,
            startDate: formFields.startDate ? formFields.startDate + " 13:00:00" : null,
            notes: formFields.notes || "",
        };
        updateEvent(payload).then(() => {
            notification.success({
                message: "Kayıt başarıyla güncellendi.",
            });
            getData();
        }).catch(() => {
            notification.error({
                message: "Bir hata oluştu, bilgileri kontrol edip tekrar deneyiniz",
            });
        });
    };

    const handleFormChange = (field, value) => {
        setFormFields(prev => ({ ...prev, [field]: value }));
        if (formErrors[field]) {
            setFormErrors(prev => {
                const next = { ...prev };
                delete next[field];
                return next;
            });
        }
    };

    const tabs = [
        { key: "1", label: "Tedarikçiler" },
        { key: "2", label: "Akredite Listesi" },
        { key: "3", label: "Kayıt Listesi" },
        { key: "4", label: "Amir Listesi" },
    ];

    return (
        <>
            <div className="w-full max-w-[1400px] mx-auto">
                <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
                    <div className="flex items-center gap-3">
                        <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 dark:text-white">{event.name}</h1>
                        {event.statusId == 2 && (
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-700">
                                Arşivlenmiş
                            </span>
                        )}
                    </div>
                    <div className="flex flex-wrap items-center gap-2">
                        {event.statusId == 1 && (
                            <ConfirmButton onConfirm={onArchiveConfirm} message="Etkinliği arşivlemek istediğinizden emin misiniz?">
                                <button
                                    className="inline-flex items-center gap-2 rounded-lg bg-blue-500 px-4 py-2 text-sm font-medium text-white hover:bg-blue-600 transition-colors"
                                >
                                    <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                                    </svg>
                                    <span>Arşivle</span>
                                </button>
                            </ConfirmButton>
                        )}
                        {!event.isClosed && (
                            <ConfirmButton onConfirm={() => onCloseConfirm(event.uniqueKey, true)} message="Personel kaydını durdurmak istediğinizden emin misiniz?">
                                <button
                                    className="inline-flex items-center gap-2 rounded-lg bg-red-500 px-4 py-2 text-sm font-medium text-white hover:bg-red-600 transition-colors"
                                >
                                    <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M5.25 7.5A2.25 2.25 0 017.5 5.25h9a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25h-9a2.25 2.25 0 01-2.25-2.25v-9z" />
                                    </svg>
                                    <span>Tedarikçi Personel Kaydını Durdur</span>
                                </button>
                            </ConfirmButton>
                        )}
                        {event.isClosed && (
                            <ConfirmButton onConfirm={() => onCloseConfirm(event.uniqueKey, false)} message="Personel kaydını açmak istediğinizden emin misiniz?">
                                <button
                                    className="inline-flex items-center gap-2 rounded-lg bg-yellow-500 px-4 py-2 text-sm font-medium text-white hover:bg-yellow-600 transition-colors"
                                >
                                    <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M5.25 7.5A2.25 2.25 0 017.5 5.25h9a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25h-9a2.25 2.25 0 01-2.25-2.25v-9z" />
                                    </svg>
                                    <span>Tedarikçi Personel Kaydını Aç</span>
                                </button>
                            </ConfirmButton>
                        )}
                        <button
                            onClick={() => {
                                const win = window.open(
                                    "/event-personnel-register/" + event.uniqueKey,
                                    "Personel Yönetimi",
                                    "width=" + window.outerWidth + ",height=" + window.outerHeight
                                );
                                win.onload = function () {
                                    this.onbeforeunload = function () {
                                        getData();
                                    };
                                };
                            }}
                            className="inline-flex items-center gap-2 rounded-lg bg-green-500 px-4 py-2 text-sm font-medium text-white hover:bg-green-600 transition-colors"
                        >
                            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span>Kayıt İşlemi</span>
                        </button>
                    </div>
                </div>
                <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 p-4 lg:p-6 mb-6">
                    <div className="space-y-4">
                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
                            <div>
                                <label className="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Etkinlik Adı</label>
                                <input
                                    type="text"
                                    value={formFields.name}
                                    onChange={(e) => handleFormChange("name", e.target.value)}
                                    placeholder="Etkinlik Adı"
                                    className="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-white placeholder-gray-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                                />
                                {formErrors.name && <p className="mt-1 text-xs text-red-500">{formErrors.name}</p>}
                            </div>
                            <div>
                                <label className="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Personel sayısı</label>
                                <input
                                    type="number"
                                    value={formFields.totalPersonnelCount}
                                    onChange={(e) => handleFormChange("totalPersonnelCount", e.target.value)}
                                    placeholder="Personel Sayısı"
                                    className="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-white placeholder-gray-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                                />
                                {formErrors.totalPersonnelCount && <p className="mt-1 text-xs text-red-500">{formErrors.totalPersonnelCount}</p>}
                            </div>
                            <div>
                                <label className="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Amir ücreti</label>
                                <input
                                    type="number"
                                    value={formFields.chiefSalary}
                                    onChange={(e) => handleFormChange("chiefSalary", e.target.value)}
                                    placeholder="Amir Ücreti"
                                    className="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-white placeholder-gray-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                                />
                                {formErrors.chiefSalary && <p className="mt-1 text-xs text-red-500">{formErrors.chiefSalary}</p>}
                            </div>
                            <div>
                                <label className="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">ÖGG ücreti</label>
                                <input
                                    type="number"
                                    value={formFields.oggSalary}
                                    onChange={(e) => handleFormChange("oggSalary", e.target.value)}
                                    placeholder="ÖGG Ücreti"
                                    className="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-white placeholder-gray-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                                />
                                {formErrors.oggSalary && <p className="mt-1 text-xs text-red-500">{formErrors.oggSalary}</p>}
                            </div>
                            <div>
                                <label className="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Mekan</label>
                                <select
                                    value={formFields.placeUniqueKey}
                                    onChange={(e) => handleFormChange("placeUniqueKey", e.target.value)}
                                    className="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-white focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                                >
                                    <option value="">Mekan Seçiniz</option>
                                    {eventPlaceList.map((m) => (
                                        <option key={m.uniqueKey} value={m.uniqueKey}>{m.name}</option>
                                    ))}
                                </select>
                                {formErrors.placeUniqueKey && <p className="mt-1 text-xs text-red-500">{formErrors.placeUniqueKey}</p>}
                            </div>
                            <div>
                                <label className="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Etkinlik Tarihi</label>
                                <input
                                    type="date"
                                    value={formFields.startDate}
                                    onChange={(e) => handleFormChange("startDate", e.target.value)}
                                    className="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-white focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                                />
                                {formErrors.startDate && <p className="mt-1 text-xs text-red-500">{formErrors.startDate}</p>}
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row gap-4 items-end">
                            <div className="flex-1 w-full">
                                <label className="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Notlar</label>
                                <input
                                    type="text"
                                    value={formFields.notes}
                                    onChange={(e) => handleFormChange("notes", e.target.value)}
                                    placeholder="Etkinlik ile ilgili notlar..."
                                    className="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-white placeholder-gray-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                                />
                            </div>
                            <div className="sm:self-end pb-0.5">
                                <button
                                    onClick={saveForm}
                                    className="inline-flex items-center gap-2 rounded-lg bg-blue-500 px-6 py-2.5 text-sm font-medium text-white hover:bg-blue-600 transition-colors whitespace-nowrap"
                                >
                                    <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0z" />
                                    </svg>
                                    <span>Kaydet</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 p-4 lg:p-6">
                    {event.uniqueKey && (
                        <>
                            <div className="border-b border-gray-200 dark:border-gray-700 overflow-x-auto">
                                <nav className="flex gap-0 min-w-max">
                                    {tabs.map((tab) => (
                                        <button
                                            key={tab.key}
                                            onClick={() => setActiveTab(tab.key)}
                                            className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                                                activeTab === tab.key
                                                    ? "border-brand-500 text-brand-500"
                                                    : "border-transparent text-gray-500 hover:text-gray-700"
                                            }`}
                                        >
                                            {tab.label}
                                        </button>
                                    ))}
                                </nav>
                            </div>
                            <div className="mt-4">
                                {activeTab === "1" && <EventSupplier uniqueKey={event.uniqueKey} />}
                                {activeTab === "2" && <AccreditedList uniqueKey={event.uniqueKey} />}
                                {activeTab === "3" && <EventPersonnelRegisteredList placeUniqueKey={event.placeUniqueKey} uniqueKey={event.uniqueKey} />}
                                {activeTab === "4" && <AccreditedChefList placeUniqueKey={event.placeUniqueKey} uniqueKey={event.uniqueKey} />}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};
